import { Modal, Spin, Typography, Card, Row, Col, Tag, Divider, Button } from "antd";
import { Link } from "react-router-dom";
import { CloseOutlined, CalendarOutlined, EnvironmentOutlined, ClockCircleOutlined, InfoCircleOutlined, UserOutlined, SettingOutlined, ArrowRightOutlined } from "@ant-design/icons";
import moment from "moment";
import "./CalendarView.css";

const { Title, Text } = Typography;

export default function VerificationModal({
  isModalVisible,
  setIsModalVisible,
  selectedItemId,
  selectedItemType,
  selectedVerification,
  setSelectedVerification,
  selectedVisitas,
  setSelectedVisitas,
  loadingModal,
  generalFields,
  clienteFields,
  instalacionFields,
  visitaFields,
}) {
  return (
    <Modal
      title={null}
      visible={isModalVisible}
      onCancel={() => {
        setIsModalVisible(false);
        setSelectedVerification(null);
        setSelectedVisitas([]);
      }}
      footer={null}
      width={900}
      closeIcon={<CloseOutlined style={{ fontSize: "16px", color: "white" }} />}
      bodyStyle={{ padding: 0, borderRadius: "8px", overflow: "hidden" }}
      centered
    >
      {loadingModal ? (
        <div style={{ padding: "40px", textAlign: "center" }}>
          <Spin size="large" tip="Cargando información..." />
        </div>
      ) : (
        selectedVerification && (
          <div className="compact-modal-content">
            {/* Header - More compact */}
            <div
              style={{
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                padding: "16px 24px",
                color: "white",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "12px"
              }}
            >
              <div>
                <Title level={4} style={{ color: "white", margin: 0, display: "flex", alignItems: "center", gap: "8px" }}>
                  <InfoCircleOutlined /> {selectedVerification.ControlInterno}
                </Title>
                <Text style={{ color: "rgba(255,255,255,0.85)", fontSize: "12px" }}>
                  <CalendarOutlined style={{ marginRight: "4px" }} />
                  Creado: {moment(selectedVerification.FechaCreacion).format("DD/MM/YYYY")}
                </Text>
              </div>
              
              <Link to={`/verificaciones/${selectedItemId}`}>
                <Button 
                  type="primary" 
                  ghost 
                  size="small" 
                  icon={<ArrowRightOutlined />}
                  style={{ 
                    borderColor: "rgba(255,255,255,0.5)", 
                    color: "white",
                    borderRadius: "4px"
                  }}
                >
                  Detalles completos
                </Button>
              </Link>
            </div>

            {/* Content - Compact Layout */}
            <div style={{ padding: "16px 20px" }}>
              <Row gutter={[16, 16]}>
                {/* General & Client Info side by side */}
                <Col xs={24} md={12}>
                  <Card
                    size="small"
                    title={<><InfoCircleOutlined /> Datos Generales</>}
                    bordered={false}
                    className="compact-card"
                    headStyle={{ borderBottom: "1px solid #f0f0f0", background: "#fafafa" }}
                  >
                    <Row gutter={[8, 8]}>
                      {generalFields.map(({ key, label }) => (
                        <Col span={12} key={key}>
                          <Text type="secondary" style={{ display: "block", fontSize: "11px", lineHeight: "1.2" }}>
                            {label}
                          </Text>
                          <Text strong style={{ fontSize: "13px" }}>
                            {key === "Monto" && selectedVerification[key]
                              ? `$${parseFloat(selectedVerification[key]).toLocaleString("es-MX", { minimumFractionDigits: 2 })}`
                              : key.includes("Fecha") && selectedVerification[key]
                              ? moment(selectedVerification[key]).format("DD/MM/YYYY")
                              : selectedVerification[key] || "N/A"}
                          </Text>
                        </Col>
                      ))}
                    </Row>
                  </Card>
                </Col>

                <Col xs={24} md={12}>
                  <Card
                    size="small"
                    title={<><UserOutlined /> Cliente</>}
                    bordered={false}
                    className="compact-card"
                    headStyle={{ borderBottom: "1px solid #f0f0f0", background: "#fafafa" }}
                  >
                    <Row gutter={[8, 8]}>
                      {clienteFields.map(({ key, label }) => (
                        <Col span={24} key={key}>
                          <Text type="secondary" style={{ display: "block", fontSize: "11px", lineHeight: "1.2" }}>
                            {label}
                          </Text>
                          <Text strong style={{ fontSize: "13px" }}>
                            {selectedVerification[key] || "N/A"}
                          </Text>
                        </Col>
                      ))}
                    </Row>
                  </Card>
                </Col>

                {/* Location & Installation side by side */}
                <Col xs={24} md={12}>
                  <Card
                    size="small"
                    title={<><EnvironmentOutlined /> Ubicación</>}
                    bordered={false}
                    className="compact-card"
                    headStyle={{ borderBottom: "1px solid #f0f0f0", background: "#fafafa" }}
                  >
                    <Text style={{ fontSize: "13px" }}>
                      {selectedVerification.NombreCalle} {selectedVerification.NumeroOficial}, {selectedVerification.ColoniaOAsentamiento},{" "}
                      {selectedVerification.Municipio}, {selectedVerification.Estado}
                    </Text>
                  </Card>
                </Col>

                <Col xs={24} md={12}>
                  <Card
                    size="small"
                    title={<><SettingOutlined /> Instalación</>}
                    bordered={false}
                    className="compact-card"
                    headStyle={{ borderBottom: "1px solid #f0f0f0", background: "#fafafa" }}
                  >
                    <Row gutter={[8, 8]}>
                      {instalacionFields.map(({ key, label, suffix }) => (
                        <Col span={12} key={key}>
                          <Text type="secondary" style={{ display: "block", fontSize: "11px", lineHeight: "1.2" }}>
                            {label}
                          </Text>
                          <Text strong style={{ fontSize: "13px" }}>
                            {selectedVerification[key] ? `${selectedVerification[key]} ${suffix}` : "N/A"}
                          </Text>
                        </Col>
                      ))}
                    </Row>
                  </Card>
                </Col>

                {/* Visitas - Full width but compact */}
                {selectedVisitas.length > 0 && (
                  <Col span={24}>
                    <Card
                      size="small"
                      title={<><ClockCircleOutlined /> Visitas Programadas</>}
                      bordered={false}
                      className="compact-card"
                      headStyle={{ borderBottom: "1px solid #f0f0f0", background: "#fafafa" }}
                    >
                      {selectedVisitas.map((visita, index) => (
                        <div key={index} style={{ marginBottom: index === selectedVisitas.length - 1 ? 0 : "8px" }}>
                          <Row gutter={[12, 4]} align="middle">
                            <Col xs={24} sm={4}>
                              <Tag color="purple" style={{ margin: 0 }}>V{index + 1}</Tag>
                            </Col>
                            {visitaFields.map(({ key, label }) => (
                              <Col xs={12} sm={6} key={key}>
                                <Text type="secondary" style={{ fontSize: "11px" }}>{label}: </Text>
                                <Text strong style={{ fontSize: "12px" }}>
                                  {key.includes("Fecha") && visita[key] ? moment(visita[key]).format("DD/MM/YYYY") : visita[key] || "N/A"}
                                </Text>
                              </Col>
                            ))}
                          </Row>
                          {index < selectedVisitas.length - 1 && <Divider style={{ margin: "8px 0" }} />}
                        </div>
                      ))}
                    </Card>
                  </Col>
                )}
              </Row>
            </div>
          </div>
        )
      )}
    </Modal>
  );
}
